var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSubjectContext = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.364 11.7071C13.7545 11.3166 13.7545 10.6834 13.364 10.2929C12.9734 9.90237 12.3403 9.90237 11.9497 10.2929L6.29289 15.9497C5.90237 16.3403 5.90237 16.9734 6.29289 17.364L11.9497 23.0208C12.3403 23.4113 12.9734 23.4113 13.364 23.0208C13.7545 22.6303 13.7545 21.9971 13.364 21.6066L8.41421 16.6569L13.364 11.7071Z",
    fill: "#071A24",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6329 10.2929C22.2423 10.6834 22.2423 11.3166 22.6329 11.7071L27.5826 16.6569L22.6329 21.6066C22.2423 21.9971 22.2423 22.6303 22.6329 23.0208C23.0234 23.4113 23.6565 23.4113 24.0471 23.0208L29.7039 17.364C30.0945 16.9734 30.0945 16.3403 29.7039 15.9497L24.0471 10.2929C23.6565 9.90237 23.0234 9.90237 22.6329 10.2929Z",
    fill: "#071A24",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9398 11.3417C21.1285 10.8227 20.8608 10.2489 20.3417 10.0602C19.8227 9.87147 19.2489 10.1392 19.0602 10.6583L15.0602 21.6583C14.8715 22.1773 15.1392 22.7511 15.6583 22.9398C16.1773 23.1285 16.7511 22.8608 16.9398 22.3417L20.9398 11.3417Z",
    fill: "#071A24",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.47715 4.47715 0 10 0H26C31.5228 0 36 4.47715 36 10V22C36 27.5228 31.5228 32 26 32H10C4.47715 32 0 27.5228 0 22V10ZM10 2H26C30.4183 2 34 5.58172 34 10V22C34 26.4183 30.4183 30 26 30H10C5.58172 30 2 26.4183 2 22V10C2 5.58172 5.58172 2 10 2Z",
    fill: "#071A24",
    fillOpacity: 0.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSubjectContext);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/subject_context.a4c3ab1735acf4884c04681c554b6f67.svg";